module.exports = __webpack_public_path__ + "static/media/bigdata-download.4392eaad.jpg";